"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
//
//
//
//
//
//
var _default = {
  props: {
    time: {
      type: String,
      default: ''
    }
  }
};
exports.default = _default;